import React from 'react'

const ExpContext = React.createContext({
  ExpInfo: {},
  updateExpInfo: () => {},
})

export default ExpContext
